// components/Breadcrumb.js
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import img from "../assets/image/parallax1.jpg";
import img1 from "../assets/image/parallax3.jpg";
import axios from "axios";
import slugify from "react-slugify";
import { ApiLinkContext } from "../context/ApiLinkContext";
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";
const BreadCrumb = () => {
  const { coaching, blogCat, blog, projects } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const pageTitle = pathnames.length
    ? pathnames[pathnames.length - 1]
    : "Ana Səhifə";

  const foundSessiya = coaching.find(
    (item) => slugify(`${item.id}-${item.name}`) === pageTitle
  );

  const foundBlogCat = blogCat.find(
    (item) => slugify(`${item.id}-${item.name}`) === pageTitle
  );

  const foundBlog = blog.find(
    (item) => slugify(`${item.id}-${item.name}`) === pageTitle
  );

  const foundProjects = projects.find(
    (item) => slugify(`${item.id}-${item.name}`) === pageTitle
  );

  const changeLocation =
    pageTitle === "biography"
      ? t.bio
      : pageTitle === "projects"
      ? t.projects
      : pageTitle === "resume"
      ? t.karyeramerkezi1
      : pageTitle === "jobpostings"
      ? t.insanresurs1
      : pageTitle === "investclub"
      ? "Özbahçeci invest club"
      : pageTitle === "signin"
      ? t.signin
      : pageTitle === "signup"
      ? t.signup
      : pageTitle === "employee"
      ? t.insanresurs
      : pageTitle === "company"
      ? t.karyeramerkezi
      : foundSessiya
      ? language == "az"
        ? foundSessiya.name
        : language == "en"
        ? foundSessiya.nameEn
        : language == "tr"
        ? foundSessiya.nameTr
        : language == "ru"
        ? foundSessiya.nameRu
        : language == "de"
        ? foundSessiya.nameDe
        : language == "pl"
        ? foundSessiya.namePl
        : ""
      : foundBlogCat
      ? foundBlogCat.name
      : foundBlog
      ? language == "az"
        ? foundBlog.name
        : language == "en"
        ? foundBlog.nameEn
        : language == "ru"
        ? foundBlog.nameRu
        : language == "tr"
        ? foundBlog.nameTr
        : language == "de"
        ? foundBlog.nameDe
        : language == "pl"
        ? foundBlog.namePl
        : ""
      : pageTitle === "termsofuse"
      ? t.terms
      : pageTitle === "privacypolicy"
      ? t.privacy
      : foundProjects
      ? language == "az"
        ? foundProjects.name
        : language == "tr"
        ? foundProjects.nameTr
        : language == "en"
        ? foundProjects.nameEn
        : language == "ru"
        ? foundProjects.nameRu
        : ""
      : pageTitle == "contact"
      ? t.contactwe
      : pageTitle == "coaching"
      ? t.coaching
      : pageTitle == "coachingsubs"
      ? t.coaching
      : pageTitle == "new"
      ? t.news
      : pageTitle == "feedbacks"
      ? "Bütün Rəylərimiz"
      : pageTitle == "chronology"
      ? "XRONOLOGİYA "
      : "";

  const imgBanner = pageTitle === "biography" ? img : img1;

  return (
    <div
      className={`breadcrumb-container ${pageTitle == "contact" && "d-none"}`}
    >
      <img src={imgBanner} alt="" className="img-fluid" />
      <div className="d-flex justify-content-center">
        <h2 className="text-center">{changeLocation}</h2>
      </div>
    </div>
  );
};

export default BreadCrumb;
